// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2aHVQ","range":"MonthRangeSwitch_range__32n3E","disabled":"MonthRangeSwitch_disabled__3gCLh"};